import { useEffect } from "react";
import { GridApi } from "ag-grid-community";
import { AllocationEvaluation } from "../../queries/allocationMatrix";

interface BulkGrantFactorsCellProps {
  matchedFactors: string[];
  api?: GridApi;
}

export function getMatchedFactors(
  evaluation?: AllocationEvaluation | null
): string[] {
  if (evaluation?.matchedOn && Object.keys(evaluation.matchedOn).length > 0) {
    return Object.entries(evaluation.matchedOn).flatMap(([, val]) => {
      const values = Array.isArray(val) ? val : [val];
      return values.filter((value) => value?.toLowerCase() !== "any");
    });
  }
  return [];
}

export function BulkGrantFactorsCell({
  matchedFactors,
  api,
}: BulkGrantFactorsCellProps) {
  useEffect(() => {
    api?.resetRowHeights();
  }, [api, matchedFactors]);

  if (matchedFactors.length === 0) {
    return <span className="text-xs text-gray-light">—</span>;
  }

  return (
    <div className="flex flex-wrap gap-1 py-2">
      {matchedFactors.map((factor, idx) => (
        <span
          key={idx}
          className="px-2 py-1 rounded text-xs font-medium bg-blue-50 text-blue-600 whitespace-nowrap"
        >
          {factor}
        </span>
      ))}
    </div>
  );
}
